import React, { FC } from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { useSelector } from 'react-redux';
import { getBreadcrumbs } from 'features/page-model/ducks/get-model';
import { analyticsUtils } from 'utils';
import { sectionStyle } from './style';

export const BreadcrumpsSection: FC = () => {
  const breadcrumb = useSelector(getBreadcrumbs)?.[0];

  function sendGA(label: string) {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementName: 'breadcrumbs',
      elementText: label,
      elementBlock: label,
    });
  }

  if (breadcrumb) {
    return (
      <section className={sectionStyle}>
        <Breadcrumbs>
          <BreadcrumbsItem
            onClick={() => sendGA(breadcrumb.label)}
            href={breadcrumb.link}
            data-qa="breadcrumb"
          >
            {breadcrumb.label}
          </BreadcrumbsItem>
        </Breadcrumbs>
      </section>
    );
  }

  return null;
};
